export const FieldSchemaTypes = {
  string: "string",
  number: "number",
  currency: "currency",
  percentage: "percentage",
  date: "date",
} as const;

export type FieldSchemaType =
  (typeof FieldSchemaTypes)[keyof typeof FieldSchemaTypes];

export const AlignSchemaTypes = {
  left: "left",
  center: "center",
  right: "right",
} as const;

export type AlignSchemaType =
  (typeof AlignSchemaTypes)[keyof typeof AlignSchemaTypes];

interface FundHoldingSchemaColumn {
  field: string;
  titleKey: string;
  type: FieldSchemaType;
  flex?: number;
  align?: AlignSchemaType;
  showOnMobileCard?: boolean;
}

export type FundHoldingSchema = FundHoldingSchemaColumn[];
